var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30983_245153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02848 28.6047L5.77344 20.9953L13.3829 20.7402L13.6379 28.3497L6.02848 28.6047ZM6.454 21.6322L6.66511 27.9238L12.9567 27.7127L12.7456 21.4211L6.454 21.6322Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.738 12.1445C23.738 13.4667 22.6659 14.5391 21.3434 14.5391C20.0213 14.5391 18.9492 13.467 18.9492 12.1445C18.9492 10.8224 20.0213 9.75 21.3434 9.75C22.6659 9.75033 23.738 10.8224 23.738 12.1445Z",
    fill: "#DC6803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1988 12.018L62.0663 12.5266L67.1211 13.844L67.2536 13.3353L62.1988 12.018Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0642 10.3419L63.7462 15.3965L64.2548 15.5291L65.5728 10.4745L65.0642 10.3419Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3174 35.3474C73.0087 35.1337 71.3043 33.0814 71.5181 30.7728C71.7318 28.4638 73.7841 26.7594 76.0928 26.9732C78.4017 27.1869 80.1061 29.2392 79.8924 31.5482C79.6786 33.8568 77.6263 35.5612 75.3174 35.3474ZM76.0353 27.5943C74.0692 27.4122 72.3216 28.8639 72.1395 30.8303C71.9575 32.7966 73.4088 34.5443 75.3752 34.7263C77.3416 34.9084 79.0892 33.4567 79.2713 31.4903C79.453 29.524 78.0016 27.7763 76.0353 27.5943Z",
    fill: "#1C273B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8592 10.7354L3.08226 67.9845C0.229829 72.5485 3.34953 78.6158 8.54429 78.6092C60.003 78.5438 40.8295 78.6115 80.0952 78.6234C85.287 78.6251 88.4011 72.5604 85.5506 67.9987L49.7644 10.7354C47.1875 6.61165 41.4361 6.61165 38.8592 10.7354Z",
    fill: "#F46E00",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7539 64.2424C40.7539 62.0573 42.2713 60.4791 44.3351 60.4791C46.5202 60.4791 47.9164 62.0573 47.9164 64.2424C47.9164 66.3667 46.5202 68.0057 44.3351 68.0057C42.2105 68.0057 40.7539 66.3667 40.7539 64.2424ZM42.2482 54.7746L41.4457 27.2629C41.4325 26.8057 41.7995 26.4277 42.2571 26.4277H46.4128C46.8704 26.4277 47.2374 26.8057 47.2242 27.2629L46.4218 54.7746C46.4089 55.2133 46.0494 55.5625 45.6104 55.5625H43.0596C42.6205 55.5625 42.2611 55.2137 42.2482 54.7746Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0504 10.8188L3.1362 70.8338C0.671625 75.6182 4.28292 81.4066 9.45918 80.9699C60.7358 76.6443 41.6337 78.2992 80.7656 75.0599C85.9395 74.6317 88.5412 68.3299 85.3224 64.0198L44.9183 9.91588C42.0087 6.0198 36.2771 6.4962 34.0504 10.8188Z",
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3652 63.9878C40.1841 61.8104 41.5658 60.1119 43.6223 59.9411C45.7998 59.7601 47.3218 61.2174 47.5029 63.3948C47.6786 65.5119 46.4232 67.2608 44.2457 67.4416C42.1287 67.6176 40.5413 66.1052 40.3652 63.9878ZM41.0709 54.4292L37.9935 27.0784C37.9423 26.6238 38.2769 26.2168 38.7328 26.1788L42.8744 25.8349C43.3303 25.7969 43.7274 26.1431 43.7518 26.6L45.2299 54.0836C45.2534 54.522 44.9243 54.8997 44.4866 54.936L41.9444 55.1471C41.507 55.1834 41.1198 54.8653 41.0709 54.4292Z",
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30983_245153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 74.258,
    fill: "white",
    transform: "translate(2 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.fd8dc4d87dc17ff6bdc114460d8c8ff1.svg";
export { ForwardRef as ReactComponent };